import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SuperAdminContainer from "../../superAdmin/SuperAdminContainer";
import { ScreenHeader, TabNav, ChantButton } from "../../../CommonComponents";
import IconContainer from "../../../CommonComponents/IconContainer";
import { PlusOutlined } from "@ant-design/icons";
import { isMobile } from "../../../utils/helper";
import PartnersList from "./PartnersList";
import Report from "./Report";

const Partners = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = () => {
    if (location.pathname.includes("/list")) {
      return "list";
    }
    if (location.pathname.includes("/report")) {
      return "report";
    }
    return "list";
  };

  const menuItems = [
    {
      key: "list",
      label: "Partners",
    },
    {
      key: "report",
      label: "Donations",
    },
  ];

  const handleTabChange = (tabKey) => {
    switch (tabKey) {
      case "list":
        navigate("/admin/partners/list");
        break;
      case "report":
        navigate("/admin/partners/report");
        break;
      default:
        navigate("/admin/partners/list");
    }
  };

  const renderContent = () => {
    if (location.pathname.includes("/list")) {
      return <PartnersList handleTabChange={handleTabChange} />;
    }

    if (location.pathname.includes("/report")) {
      return <Report handleTabChange={handleTabChange} />;
    }

    return <PartnersList handleTabChange={handleTabChange} />;
  };

  return (
    <SuperAdminContainer>
      <ScreenHeader
        title="Partners"
        style={{ marginBottom: "2px" }}
        actions={
          <>
            {getCurrentTab() === "list" && (
              <div>
                {isMobile() ? (
                  <IconContainer
                    onClick={() => navigate("/admin/partners/add")}
                    iconComponent={<PlusOutlined />}
                    iconStyle={{ fontSize: "16px" }}
                  />
                ) : (
                  <ChantButton onClick={() => navigate("/admin/partners/add")}>
                    Add Partner
                  </ChantButton>
                )}
              </div>
            )}
          </>
        }
      />
      <div>
        <TabNav
          items={menuItems}
          activeKey={getCurrentTab()}
          handleTabChange={handleTabChange}
        />
      </div>

      <div style={{ marginTop: "2px" }}>{renderContent()}</div>
    </SuperAdminContainer>
  );
};

export default Partners;
